import { User } from '@bybeam/platform-types';

export function hasFullProfile(user?: Partial<User>): boolean {
  if (!user) return false;
  const { name, email } = user;
  if (name === email) return false;
  if ([name, email].some((thing) => !thing)) return false;
  return true;
}
